const doc = [["events-2027", "2025-04-02"]];
module.exports = doc.length <= 1 ? doc[0] : doc;